import usePageData from "@/api/hooks/usePageData";
import GlobeLoading from "@/components/GlobeLoading";
import WhyChooseUs from "@/components/WhyChooseUs";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";


const AboutUs: React.FC = () => {

  const {
    page,
    data: pageData,
    isLoading,
    localization
  } = usePageData();

  useEffect(() => {
    jQuery("#our-clinic, #our-hospital, #meet-specialist-carousel").owlCarousel({
      singleItem: true,
      navigation: true
    });
  }, []);


  return (
    <>
      <Helmet>
        <title>
          {page?.name}
        </title>
        <meta name="description" content={localization?.dict["page.description"]?.value} />
      </Helmet>
      <GlobeLoading isLoading={isLoading} />
      {pageData ? (
        <>

          <div>
            {/* Sub Page Banner */}
            <section
              className="sub-page-banner text-center"
              style={{
                backgroundAttachment: "fixed",
                backgroundSize: "cover",
                backgroundImage: `url(https://minimar.b-cdn.net/uploads/images/thumbnail-1732625990113-644831127.jpg)`,
              }}
            >
              <div className="overlay" style={{ background: "rgba(0,0,0,0.5)" }}></div>
              <div className="container">
                <h1 className="entry-title">
                  {localization?.dict["page.title"]?.value}
                </h1>
                <br />
                <p>
                  {localization?.dict["page.description"]?.value}
                </p>
              </div>
            </section>

            {/* Sub Page Content */}
            <div id="sub-page-content">
              <div className="container big-font">
                <h2 className="light bordered main-title"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}
                  dangerouslySetInnerHTML={{ __html: localization?.dict["who-we-are.title"]?.value }}
                >
                </h2>
                <article
                  dangerouslySetInnerHTML={{ __html: localization?.dict["who-we-are.content"]?.value }}
                >

                </article>
              </div>

              <div className="height20" style={{ height: "20px" }}></div>
            </div>

            {/*Features*/}
            <section className="features">

              <div className="container">

                <div className="row">

                  <div className="col-md-6">

                    <div className="feature">
                      <i className="pull-left feature-icon fa fa-clock-o"></i>
                      <div className="feature-content">
                        <h5>
                          {localization?.dict["our-mission.title"]?.value}
                        </h5>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: localization?.dict["our-mission.content"]?.value
                          }}
                        ></div>
                      </div>
                    </div>

                  </div>

                  <div className="col-md-6">

                    <div className="feature">
                      <i className="pull-left feature-icon fa fa-tint"></i>
                      <div className="feature-content">
                        <h5>
                          {localization?.dict["our-vision.title"].value}
                        </h5>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: localization?.dict["our-vision.content"].value
                          }}
                        ></div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

            </section>
            {/*Our Hospitals and Why Choose Medicom**/}
            <div className="container padding-top-35 clearfix">
              <div className="row">
                <div className="col-md-12">

                  <WhyChooseUs
                    title={localization?.dict["whychooseus.title"]?.value}
                    data={pageData?.WhyChooseUs}
                  />
                </div>

              </div>

            </div>

            {/*pageData?.populated?.AboutUs_Submodule?.records?.find((record: any) => record.section === "pdf" && record.is_active !== false)?.length > 0 &&
              <section >
                <div className="container big-font">
                  <div className="row">
                    <h2 className="light bordered">Fİrma <span>Belgelerİ</span></h2>
                    {pageData?.populated?.AboutUs_Submodule?.records?.find((record: any) => record.section === "pdf" && record.is_active !== false)?.map((item: any, index: number) => (
                      <div key={index + "-pdf"}>
                        <div style={{ display: "flex", gap: "20px", flex: 1 }}>
                          <PdfViewer pdfUrl={item.pdf} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            */}

            {/*<CatalogPage />*/}

            <div className="colourfull-row"></div>
          </div >
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default AboutUs;
